import { EmptyState } from '@/components/ui/empty-state';
import { Box, HStack } from '@chakra-ui/react';
import { WarningTriangle } from 'iconoir-react';
import { useTranslation } from 'react-i18next';
import ContactOutlineButton from './ContactOutlineButton';
import ContactPrimaryButton from './ContactPrimaryButton';

interface ContactDrawerErrorStateProps {
  onRetry: () => void;
  onClose: () => void;
}

/**
 * Full-panel error body shown inside the drawer shell when the contact could
 * not be resolved or its summary failed to load (settled error, not loading).
 * Icon + short copy + retry and close affordances, so a 404/5xx is
 * distinguishable from the loading skeletons instead of a blank header-less
 * shell.
 */
const ContactDrawerErrorState: React.FC<ContactDrawerErrorStateProps> = ({ onRetry, onClose }) => {
  const { t } = useTranslation();

  return (
    <Box flex="1" display="flex" alignItems="center" justifyContent="center" p="24px">
      <EmptyState
        maxW="420px"
        icon={<WarningTriangle width={20} height={20} />}
        title={t('contactDrawer.error.title')}
        description={t('contactDrawer.error.description')}
      >
        <HStack gap="2.5">
          <ContactPrimaryButton h="38px" onClick={onRetry}>
            {t('contactDrawer.error.retry')}
          </ContactPrimaryButton>
          <ContactOutlineButton h="38px" onClick={onClose}>
            {t('contactDrawer.actions.close')}
          </ContactOutlineButton>
        </HStack>
      </EmptyState>
    </Box>
  );
};

export default ContactDrawerErrorState;
